module.exports = __webpack_public_path__ + "static/img/slide2.9e457a89.jpg";